import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Overline } from "@/components/Motion";
import { IMAGES, CONTACT } from "@/data/content";

const ReservationCTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="reserve" ref={ref} className="relative overflow-hidden py-36 sm:py-48" data-testid="reservation-cta-section">
      <motion.div style={{ y, scale: 1.25 }} className="absolute inset-0 will-change-transform">
        <img
          src={IMAGES.reserve}
          alt="A candlelit dinner table set for two with mocktails"
          loading="lazy"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-ink/65" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-3xl px-6 text-center text-cream">
        <Reveal>
          <Overline className="text-brass">Reservations</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tight mt-5">
            Your Table <span className="italic text-brass">Awaits</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 text-cream/85 text-base md:text-lg font-light leading-relaxed">
            Whether it's a romantic evening, a family celebration, or simply a night of exceptional
            food, we'd love to have you at our table.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <Link
            to="/reservations"
            data-testid="reserve-cta-btn"
            className="mt-10 inline-block rounded-full bg-wine px-12 py-5 text-sm tracking-[0.16em] uppercase text-cream hover:bg-winedark hover:scale-[1.04] active:scale-95 transition-all duration-300 shadow-[0_20px_50px_-15px_rgba(114,47,55,0.6)]"
          >
            Reserve Your Table
          </Link>
        </Reveal>
        <Reveal delay={0.4}>
          <p className="mt-8 text-cream/60 text-xs tracking-[0.2em] uppercase">
            For parties of 8 or more, please call {CONTACT.phone}
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default ReservationCTA;
